/* eslint-disable no-param-reassign */
import { createActionTypeReducer } from 'util/reducers'
import { buildId } from 'util/globalId'
import {
  queryIdToQuery,
  constructFolderItemQueryId,
} from 'ducks/searches/utils/query'
import { CHAT_PAGE } from 'subapps/chat/pages'
import { BUILD_FROM_WIDGETS } from '../actionTypes/collections'
import { SET_ITEMS_BYID } from '../actionTypes/items'

const itemsByIdInitialState = {}
const folderKindsWithUnreadIndicator = ['unassigned', 'mine']

export const itemsById = createActionTypeReducer(
  {
    [SET_ITEMS_BYID]: (_, { payload: { items = [] } }) => {
      return items.reduce((itemById, item) => {
        itemById[item.id] = item
        return itemById
      }, {})
    },
    [BUILD_FROM_WIDGETS]: (
      draftState,
      {
        payload: {
          widgets = [],
          folders = [],
          prefersAllMailboxesSectionVisible = false,
          prefersUnifiedInbox = false,
        },
      }
    ) => {
      const validItems = []
      const hasAccessToAtleastOneWidget = widgets.some(w => w.hasAccess)

      const allowedWidgets = prefersUnifiedInbox
        ? []
        : [...widgets.filter(w => w.hasAccess)]

      if (
        hasAccessToAtleastOneWidget &&
        (prefersUnifiedInbox ||
          (prefersAllMailboxesSectionVisible && allowedWidgets.length > 1))
      ) {
        allowedWidgets.unshift({
          id: '',
          name: 'All widgets',
          hasAccess: true,
        })
      }

      allowedWidgets.forEach(widget => {
        const { id: rawWidgetId } = widget
        const widgetId = buildId('Widget', rawWidgetId)
        folders.forEach(folder => {
          const {
            id: folderId,
            position,
            displayCountWhenInactive,
            name,
          } = folder
          let itemId = `${folderId}`
          if (rawWidgetId) {
            itemId = `${widgetId}_${itemId}`
          }
          validItems.push(itemId)
          const itemQueryId = constructFolderItemQueryId({ widget, folder })
          if (
            !draftState[itemId] &&
            // FIXME: Until we have chat folder permissions, hide facebook specific folders
            // for non-facebook widgets
            (!['New messages', 'Ending soon'].includes(name) ||
              widget.kind === 'facebook')
          ) {
            draftState[itemId] = {
              id: itemId,
              name,
              groupId: null,
              collectionId: rawWidgetId ? widgetId : '',
              position,
              displayCountWhenInactive,
              displayUnreadIndicator: folderKindsWithUnreadIndicator.includes(
                folder.kind
              ),
              queryId: itemQueryId,
              linkTo: {
                type: CHAT_PAGE,
                payload: {},
                meta: {
                  query: queryIdToQuery(itemQueryId),
                },
              },
            }
            draftState[itemId].position = position
          }
        })
      })
      Object.keys(draftState).forEach(itemId => {
        if (!validItems.includes(itemId)) {
          delete draftState[itemId]
        }
      })
      return draftState
    },
  },
  itemsByIdInitialState
)
